import React from 'react'
import { connect } from 'react-redux'
import { selectLanguage } from '../../containers/App/selectors'
import { swapLanguage } from '../../containers/App/actions'

const LanguageProvider = WrappedComponent => {
  const LanguageProviderHOC = ({ language, swapLanguage, ...parentProps }) => {
    return (
      <WrappedComponent
        {...parentProps}
        language={language}
        swapLanguage={swapLanguage}
      />
    )
  }

  const mapStateToProps = state => ({
    language: selectLanguage(state)
  })

  const mapDispatchToProps = dispatch => ({
    swapLanguage: language => dispatch(swapLanguage(language))
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(LanguageProviderHOC)
}

export default LanguageProvider



// WEBPACK FOOTER //
// ./src/containers/LanguageProvider/LanguageProvider.js